import React, { FunctionComponent } from 'react'
import { useIntl } from 'react-intl'

import { MessageAttachmentData } from '../..'
import { MessageAttachmentType } from '../../ui-models/messages/Messages'
import { DirectBookingLinkMessageAttachment } from '../directBookingLinkMessageAttachment/DirectBookingLinkMessageAttachment'
import { EssentialsLinkMessageAttachment } from '../essentialsLinkMessageAttachment/EssentialsLinkMessageAttachment'

export type MessageAttachmentRendererProps = {
  attachment: MessageAttachmentData
  onPress?: (attachment: MessageAttachmentData) => void
  dblAttachmentsDisabled?: boolean
}

export const MessageAttachmentRenderer: FunctionComponent<MessageAttachmentRendererProps> = ({
  onPress,
  attachment,
  dblAttachmentsDisabled,
}) => {
  const { formatMessage } = useIntl()

  switch (attachment.type) {
    case MessageAttachmentType.DBL:
      return (
        <DirectBookingLinkMessageAttachment
          onPress={() => onPress?.(attachment)}
          disabled={dblAttachmentsDisabled}
          disabledTooltipContent={formatMessage({
            defaultMessage: 'This provider is not currently available for booking',
            description: 'Tooltip shown when the direct booking link is disabled because the provider is blocked',
          })}
        />
      )
    case MessageAttachmentType.ESSENTIALS_LINK:
      return <EssentialsLinkMessageAttachment onPress={() => onPress?.(attachment)} text={attachment.url} />
    default:
      return null
  }
}
